"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackSchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
const enums_1 = require("../enums");
exports.FeedbackSchema = base_1.BaseSchema.extend({
    storeId: base_1.ShortStringSchema.uuid(),
    rating: zod_1.z.number().min(0).max(10).optional(),
    comment: base_1.MediumStringSchema.optional(),
    sourceDevice: base_1.ShortStringSchema.optional(),
    type: zod_1.z.nativeEnum(enums_1.FeedbackType).default(enums_1.FeedbackType.Nps).optional(),
});
//# sourceMappingURL=index.js.map